var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHousehold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "19px",
    viewBox: "0 0 18 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D941F082-3C9B-49F0-9377-C938FFEFC7C7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Week-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application-Summary-Cards",
    transform: "translate(-387.000000, -506.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "My-Details",
    transform: "translate(360.000000, 387.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(0.000000, 88.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-/-household",
    transform: "translate(24.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,13 C14.209139,13 16,11.209139 16,9 C16,8.23521588 15.7853685,7.52056164 15.4130544,6.91298627 C14.1943058,8.00244141 11.4799345,8.00244141 10.079834,8.00244141 C9.09559679,8.00244141 8.4263247,8.70938482 8.01662509,9.36715389 C8.20199731,11.404201 9.91463924,13 12,13 Z M6,9 C6,5.6862915 8.6862915,3 12,3 C15.3137085,3 18,5.6862915 18,9 C18,10.5367089 17.4222929,11.938487 16.472213,13 L17.986304,13 C18.5361709,13 19.1017113,13.4301213 19.250671,13.9650016 L20.9411477,20.0351204 C21.0895713,20.5680761 20.7631681,21.0004902 20.2052961,21.00095 L3.77289949,21.0144919 C3.21807623,21.0149492 2.88731711,20.5843814 3.03531778,20.048485 L4.7149115,13.9668348 C4.86237963,13.4328667 5.43187492,13 5.97754832,13 L7.52778699,13 C6.57770714,11.938487 6,10.5367089 6,9 Z M17.4594042,15.0000967 L6.50303836,15.0021072 L5.39233733,19 L18.5845885,19.0008467 L17.4594042,15.0000967 Z",
    id: "path"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousehold);
export default __webpack_public_path__ + "static/media/household.51c7075b7593a5cdd6329cafbc590817.svg";
export { ForwardRef as ReactComponent };